export class Project {
  idProject: number;
  title: string;
  description: string;
  posizione: number;
  image: string;
  lang: string;
}